module.exports = "/images/vendor/vue-paycard/src/6.jpg?394fa5772d9964240f4de38ba4504d6a";